import {
    loadSearchResultsComponent,
    loadScheduleServiceComponent,
    loadSearchComponent,
    loadGetAQuoteComponent,
    loadIframeStyle,
} from "./loaders";
import { Config, InitParams } from "./types";
import {
    renderDialog,
    renderButtons,
    onOpenTireDialog,
    onOpenScheduleDialog,
} from "./iframeDialog";
import { loadRudderStack } from "./loadRudderStack";

function init(params: InitParams) {
    const config: Config = {
        ...params,
        iframeBaseUrl: process.env.IFRAME_BASE_URL,
    };

    window.tt.config = config;

    loadIframeStyle();

    const componentLoaders = [
        loadSearchComponent,
        loadSearchResultsComponent,
        loadScheduleServiceComponent,
        loadGetAQuoteComponent,
    ];

    componentLoaders.forEach((loadComponent) => {
        try {
            loadComponent();
        } catch (e) {
            console.error(`TireTutor Integration: Error in ${loadComponent.name}:`, e);
        }
    });

    const dialog = renderDialog();

    window.tt.openTireDialog = () => onOpenTireDialog(dialog);
    window.tt.openScheduleDialog = () => onOpenScheduleDialog(dialog);

    renderButtons(dialog);

    loadRudderStack(process.env.RS_WRITE_KEY, process.env.RS_DATA_PLANE_URL);
}

export { init };
